import React from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import rsGrb from '../assets/images/RS-grb-1.png';
import euLogo from '../assets/images/EU-1.png';
import undpLogo from '../assets/images/UNDP.png';
import swedenLogo from '../assets/images/Sweeden.png';
import eibLogo from '../assets/images/Eib.png';
import swissLogo from '../assets/images/Svajcarska.png';
import greenAgenda from '../assets/images/EU-zelena-agenda-1.png';

const Footer = () => {
  const { t } = useLanguage();
  const location = useLocation();
  const isMapPage = location.pathname === '/';

  return (
    <footer className="app-footer">
      <div className="footer-logos">
        <img src={rsGrb} alt="Republika Srbija" className="footer-logo" />
        <img src={euLogo} alt="European Union" className="footer-logo" />
        <img src={undpLogo} alt="UNDP" className="footer-logo" />
        <img src={swedenLogo} alt="Sweden" className="footer-logo" />
        <img src={eibLogo} alt="EIB" className="footer-logo" />
        <img src={swissLogo} alt="Swiss" className="footer-logo" />
        <img src={greenAgenda} alt="EU za Zelenu agendu u Srbiji" className="footer-logo" />
      </div>
      <div className="footer-green-bar">
        <p>
          Ova aplikacija je izrađena uz podršku projekta „EU za Zelenu agendu u Srbiji".
        </p>
        {isMapPage && (
          <p className="footer-disclaimer">
            Svako pominjanje Kosova se čini u kontekstu Rezolucije 1244 Saveta bezbednosti Ujedinjenih nacija (1999. god.)
          </p>
        )}
      </div>
    </footer>
  );
};

export default Footer;
